
<template>
  <div class="ma-5">
    <div class="manage-department-title title-notab pt-6 pb-6">
    ตั้งค่าบริการการใช้งาน
    </div>
  <v-row class="pt-8">
    <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">เครือบริษัท</span>
        <v-autocomplete
          v-model="keywordCompanyGroup"
          :items="itemsCompanyGroup"
          item-text="groupCompanyNameFull"
          item-value="groupCompanyId"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาเครือบริษัท"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordCompanyGroup='', searchFilterData(), page=1"
        >
        <template v-slot:selection="data">
          <v-chip
            class="mt-1 mb-1"
            color="#EFF4FD"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            close-icon="mdi-close"
            label
            filter
            small
            @click:close="keywordCompanyGroup.splice(keywordCompanyGroup.indexOf(data.item), 1)"
            style="color: #999999;"
          >
            <span style="color: #3776E9;">{{ data.item.groupCompanyNameFull }}</span>
          </v-chip>
        </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">บริษัท</span>
        <v-autocomplete
          v-model="keywordCompanyName"
          :items="itemsCompany"
          item-text="companyNameFull"
          item-value="companyId"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาบริษัท"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordCompanyName='', searchFilterData(), page=1"
        >
        <template v-slot:selection="data">
          <v-chip
            class="mt-1 mb-1"
            color="#EFF4FD"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            close-icon="mdi-close"
            label
            filter
            small
            @click:close="keywordCompanyName.splice(keywordCompanyName.indexOf(data.item), 1)"
            style="color: #999999;"
          >
            <span style="color: #3776E9;">{{ data.item.companyNameFull }}</span>
          </v-chip>
        </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">ชื่อ service</span>
        <v-autocomplete
          v-model="keywordServiceName"
          :items="itemsServices"
          item-text="serviceName"
          item-value="_id"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาชื่อ service"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordServiceName='', searchFilterData(), page=1"
        >
        <template v-slot:selection="data">
          <v-chip
            class="mt-1 mb-1"
            color="#EFF4FD"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            close-icon="mdi-close"
            label
            filter
            small
            @click:close="keywordServiceName.splice(keywordServiceName.indexOf(data.item), 1)"
            style="color: #999999;"
          >
            <span style="color: #3776E9;">{{ data.item.serviceName }}</span>
          </v-chip>
        </template>
        </v-autocomplete>
      </v-col>
    <v-spacer/>
    <v-btn
      color="primary"
      elevation="0"
      class="mr-3 mt-9"
      right
      bottom
      @click="createService()"
    >
      <v-icon left size="14px">
        mdi-plus
      </v-icon>
      เพิ่ม service
    </v-btn>
  </v-row>
  <OverlayLoading :loading="loadingService" />
  <div>
    <v-data-table
      class="border-table-employee"
      item-key="_id"
      :headers="headers"
      :items="dataSource"
      :loading="loadingService"
      loading-text="Loading... Please wait"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100, -1],
        'items-per-page': 15,
        'items-length': 1
      }"
      :server-items-length="total || -1"
      disable-sort
      @update:items-per-page="changePerPage"
      @update:page="changePage"
    >
      <template v-slot:[`item.no`]="{ item }">
        {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
      </template>
      <template v-slot:[`item.serviceStatus`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on">
            <v-switch
              v-model="item.isOn"
              style="transform: scale(0.8); margin-left: -15px;"
              color="primary"
              flat
              inset
              dense
              readonly
              @click="dialogConfirmChangeStatus = true, onFocusServiceStatus = item"
            ></v-switch>
          </div>
        </template>
          <span class="label-table-action">เปิด/ปิด การใช้งาน Service <br>เมื่อปิดใช้งานจะไม่สามารถ <br>login เข้า Service นี้ได้</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#FFB300"
                dark
                icon
                class="ra-border-button mt-3 mb-3"
                @click="clickEditService(item)"
              >
              <v-icon color="#3776E9" small>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">แก้ไขข้อมูล Service</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#FFB300"
                dark
                icon
                class="ra-border-button mt-3 mb-3 ml-2"
                @click="dialogConfirmRemove = true, onFocusServiceRemove = item"
              >
              <v-icon color="error" small>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ลบ service</span>
          </v-tooltip>
        </template>
    </v-data-table>
  </div>
  <dialogShowService/>
  <v-dialog v-model="dialogConfirmChangeStatus" max-width="380px" persistent>
    <v-card >
      <v-card-title class="ra-head-text-bold justify-center pa-5">
        ต้องการ{{ onFocusServiceStatus.globalStatus==='off'? 'เปิด':'ปิด' }}การใช้งาน Service ใช่ไหม
      </v-card-title>
      <v-card-text class="justify-center text-center">
      <span class="ra-head-text justify-center" style="font-size: 16px;">คุณแน่ใจหรือไม่ว่าต้องการ{{ onFocusServiceStatus.globalStatus==='off'? 'เปิด':'ปิด' }}การใช้งาน Service นี้</span>
      </v-card-text>
      <v-card-actions class="justify-center mt-0 pb-5">
          <v-btn
            color="primary"
            outlined
            class="head-search-button mr-4"
            width="100"
            @click="dialogConfirmChangeStatus = false"
          >
          ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            class="head-search-button ml-4 white--text text--lighten-4"
            elevation="0"
            width="100"
            @click="toggleStatus(onFocusServiceStatus), dialogConfirmChangeStatus = false"
          >
          ยืนยัน
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogConfirmRemove" max-width="344px" persistent>
    <v-card >
      <v-card-title class="ra-head-text-bold justify-center pa-5">
        ต้องการลบข้อมูลใช่ไหม
      </v-card-title>
      <v-card-text class="justify-center text-center">
      <span class="ra-head-text justify-center" style="font-size: 16px;">คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล</span>
      </v-card-text>
      <v-card-actions class="justify-center mt-0 pb-5">
          <v-btn
            color="primary"
            outlined
            class="head-search-button mr-4"
            width="100"
            @click="dialogConfirmRemove = false"
          >
          ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            class="head-search-button ml-4 white--text text--lighten-4"
            elevation="0"
            width="100"
            @click="clickRemoveService(onFocusServiceRemove), dialogConfirmRemove = false"
          >
          ยืนยัน
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-snackbar
    v-model="snackbar"
    :timeout="2000"
    top
    centered
    elevation="1"
    color="#ECF8EA"
    app
  >
    <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
    <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
      {{ snackbarText }}
    </span>
  </v-snackbar>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import dialogShowService from './_dialog/dialogShowService'
import {
  deleteService,
  getAllServiceSetting,
  updateGlobalStatusService
} from '@/API/API'
import OverlayLoading from '@/components/_template/OverlayLoading.vue'
import swal from 'sweetalert'
const axios = require('axios')

export default {
  name: 'tree',
  components: {
    OverlayLoading, dialogShowService
  },
  data () {
    return {
      isAdmin: (this.$store.state.user.role).includes('administrator'),
      keywordCompanyGroup: '',
      keywordCompanyName: '',
      keywordServiceName: '',
      keywordStatus: '',
      headers: [
        {
          text: 'ลำดับ',
          align: 'left fixed',
          value: 'no',
          width: '70px',
          groupable: false,
          sortable: false,
          class: 'column-fix'
        },
        { text: 'ชื่อ Service', value: 'serviceName', align: 'left' },
        { text: 'เครือบริษัท', value: 'groupCompanyNameFull', width: '' },
        { text: 'บริษัท', value: 'companyNameFull', width: '' },
        { text: 'สถานะ', value: 'serviceStatus', width: '160' },
        { text: 'จัดการ', align: 'center', width: '120px', value: 'actions', sortable: false }
      ],
      dataSource: [],
      total: -1,
      statusList: [
        { value: 'on', text: 'Active' },
        { value: 'off', text: 'InActive' }
      ],
      loadingService: true,
      perPage: 15,
      page: 1,
      itemsCompanyGroup: [],
      itemsCompany: [],
      itemsServices: [],
      dialogConfirmChangeStatus: false,
      onFocusServiceStatus: '',
      dialogConfirmRemove: false,
      onFocusServiceRemove: '',
      snackbar: false,
      snackbarText: '',
      role: ''
    }
  },
  async created () {
    this.role = localStorage.approveRole.toLowerCase()
    await this.getSelectorData()
    await this.searchFilterData()
  },
  beforeDestroy () {
    EventBus.$off('openDialogViewService')
  },
  mounted () {
    EventBus.$on('closeDialogViewService', async (e) => {
      await this.searchFilterData()
    })
    EventBus.$on('setApproveRole', this.setRole)
  },
  methods: {
    async setRole () {
      this.role = localStorage.approveRole.toLowerCase()
      this.page = 1
      await this.getSelectorData()
      await this.searchFilterData()
    },
    snackbarActive (text) {
      this.snackbarText = text
      this.snackbar = true
    },
    changePerPage (value) {
      this.perPage = value
      this.searchFilterData()
    },
    changePage (value) {
      this.page = value
      this.searchFilterData()
    },
    async getSelectorData () {
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/service/selectorService`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: { role: 'admin' }
        })
          .then((response) => {
            if (response.data.success === true) {
              this.itemsCompanyGroup = response.data.group
              this.itemsCompany = response.data.company
              this.itemsServices = response.data.result
            } else {
              this.itemsCompanyGroup = []
              this.itemsCompany = []
              this.itemsServices = []
            }
          })
          .catch(function (thrown) {
          })
      } catch (error) { } finally {
      }
    },
    async searchFilterData () {
      var self = this
      var searchKeysAdmin = {
        serviceId: this.keywordServiceName || '',
        companyId: this.keywordCompanyName || '',
        groupId: this.keywordCompanyGroup || '',
        role: this.role,
        // globalStatus: this.keywordStatus,
        limit: this.perPage,
        page: this.page
      }
      self.loadingService = true
      try {
        const res = await getAllServiceSetting(this.$store.state.token, searchKeysAdmin)
        if (res.success === true) {
          self.total = res.count
          self.dataSource = res.result
          self.dataSource.map(e => {
            e.isOn = e.globalStatus === 'on'
            e.companyList = [...new Set(e.companyId.map(x => x.companyName))] || '-'
            e.groupCompanyName = e.groupCompanyId[0] ? e.groupCompanyId[0].groupCompanyName : '-'
            e.groupCompanyNameFull = e.groupCompanyId[0] ? e.groupCompanyId[0].groupCompanyNameFull : '-'
            e.companyName = e.companyId[0] ? e.companyId[0].companyName : '-'
            e.companyNameFull = e.companyId[0] ? e.companyId[0].companyNameFull : '-'
          })
        } else {
          self.dataSource = []
        }
      } catch (error) {
        self.dataSource = []
        console.log(error)
      } finally {
        self.loadingService = false
      }
    },
    resetFilterData () {
      this.keywordServiceName = ''
      this.keywordStatus = ''
      this.searchFilterData()
    },
    async toggleStatus (item) {
      const self = this
      self.loadingService = true
      const obj = {
        globalStatus: item.globalStatus === 'on' ? 'off' : 'on',
        serviceId: item._id
      }

      try {
        const res = await updateGlobalStatusService(this.$store.state.token, obj)
        if (res.success) {
          // swal('สำเร็จ', 'เปลี่ยนสถานะสำเร็จ', 'success', {
          //   button: false,
          //   timer: 1000
          // })
          this.snackbarActive(item.globalStatus === 'on' ? 'คุณได้ทำการปิดการใช้งาน Service เรียบร้อยแล้ว' : 'คุณได้ทำการเปิดการใช้งาน Service เรียบร้อยแล้ว')
        }
      } catch (error) {
        console.log(item, error)
        swal('ผิดพลาด', 'เปลี่ยนสถานะไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 3000
        })
      } finally {
        self.searchFilterData()
        self.loadingService = false
      }
    },
    createService () {
      // console.log('createService')
      this.$router.push('/settingservices/createservice')
    },
    createRequestService () {
      // console.log('createRequestService')
      this.$router.push('/authorityservices/myservicelist/create')
    },
    clickViewService (item) {
      // console.log('clickViewService', item)
      EventBus.$emit('openDialogViewService', true, item, 'view')
    },
    clickEditService (item) {
      // this.dialogEdit = true
      // EventBus.$emit('openDialogViewService', true, item, 'edit')
      this.$router.push('settingservices/update/' + item._id)
    },
    async clickRemoveService (item) {
      // swal('ยืนยันการลบ ใช่หรือไม่?', `service: ${item.serviceName} `, 'warning', {
      //   buttons: [
      //     'ยกเลิก',
      //     'ยืนยัน'
      //   ],
      //   dangerMode: true
      // })
      //   .then(async (confirm) => {
      //     if (confirm) {
      //       // console.log('clickRemoveService', item)
      //       const obj = {
      //         serviceId: item._id
      //       }
      //       try {
      //         const res = await deleteService(obj, this.$store.state.token)
      //         if (res.success) {
      //           swal('สำเร็จ', 'ลบข้อมูลสำเร็จ', 'success', {
      //             button: false,
      //             timer: 2000
      //           })
      //         }
      //       } catch (error) {
      //         console.log(error)
      //         swal('ผิดพลาด', 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', 'error', {
      //           button: false,
      //           timer: 2000
      //         })
      //       } finally {
      //         this.searchFilterData()
      //       }
      //     }
      //   })
      const obj = {
        serviceId: item._id
      }
      try {
        const res = await deleteService(obj, this.$store.state.token)
        if (res.success) {
          // swal('สำเร็จ', 'ลบข้อมูลสำเร็จ', 'success', {
          //   button: false,
          //   timer: 2000
          // })
          this.snackbarActive('คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว')
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        this.searchFilterData()
      }
    }
  }
}
</script>
